import type { ExternalTableSchema } from '@packages/table-builder';

/**
 * DynamicTableV2 schema for the Financing Rounds list page.
 *
 * Data source: CloseRoundService.getApiCapTableApiAppCloseRoundClosedRoundSummaries()
 *   GET /api/cap-table/api/app/close-round/closed-round-summaries
 *   Returns: plain Array<ClosedRoundSummaryDto> (no paging wrapper — DynamicTableV2 auto-detects).
 *
 * Action IDs follow VERB_ENTITY convention — last word = domain name (FINANCING_ROUND).
 * Handlers self-register from domains/financing-round/financing-round.actions.ts.
 */
export const financingRoundTable: ExternalTableSchema = {
  metadata: {
    title: 'Financing Rounds',
    entity: 'FinancingRound',
    description: 'Committed closed financing rounds — historical record of all closed rounds.',
  },

  dataSource: {
    endpoint: '/api/cap-table/api/app/close-round/closed-round-summaries',
    method: 'GET',
    rowIdField: 'id',
  },

  columns: [
    {
      field: 'name',
      header: 'Round',
      type: 'text',
      sortable: true,
    },
    {
      field: 'closeDate',
      header: 'Close Date',
      type: 'date',
      sortable: true,
      align: 'center',
      width: 160,
    },
    {
      field: 'stockClassName',
      header: 'Stock Class',
      type: 'text',
      sortable: true,
      width: 180,
    },
    {
      field: 'pricePerShare',
      header: 'Price / Share',
      type: 'currency',
      sortable: true,
      align: 'right',
      width: 150,
    },
    {
      field: 'capitalRaised',
      header: 'Capital Raised',
      type: 'currency',
      sortable: true,
      align: 'right',
      width: 170,
    },
    {
      field: 'totalNewShares',
      header: 'New Shares',
      type: 'text',
      sortable: true,
      align: 'right',
      width: 140,
    },
  ],

  actions: {
    toolbar: {
      primary: {
        id: 'OPEN_MODELER_FINANCING_ROUND',
        label: 'Open Funding Round Modeler',
        icon: 'analytics',
      },
    },
    row: [
      { id: 'VIEW_FINANCING_ROUND', label: 'View' },
      { id: 'REVERSE_CLOSE_FINANCING_ROUND', label: 'Reverse close', variant: 'danger' },
    ],
  },

  features: {
    search: { enabled: false },
    pagination: { mode: 'infiniteScroll', defaultSize: 100 },
    columnPreferences: { persistenceKey: 'FinancingRound', resizable: true, reorderable: true },
  },
};
